import { render, staticRenderFns } from "./LessonPage.vue?vue&type=template&id=1ca0e74e&scoped=true"
import script from "./LessonPage.vue?vue&type=script&lang=js"
export * from "./LessonPage.vue?vue&type=script&lang=js"
import style0 from "./LessonPage.vue?vue&type=style&index=0&id=1ca0e74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca0e74e",
  null
  
)

export default component.exports